import { ValidateJSModel, LocationModel, ValidateJSModelAttribute } from 'forms/shared/types';
import locationModel from '../location';

interface LocationUSCityStateZipInternationalCityModel {
  city: LocationModel['city']
  state: LocationModel['state']
  country: LocationModel['country']
  zipcode: LocationModel['zipcode']
}

const locationUSCityStateZipInternationalCityModelValidator: ValidateJSModel<LocationUSCityStateZipInternationalCityModel> = {
  city: locationModel.city as ValidateJSModelAttribute<
    LocationUSCityStateZipInternationalCityModel,
    'city'
  >,
  state: locationModel.state as ValidateJSModelAttribute<
    LocationUSCityStateZipInternationalCityModel,
    'state'
  >,
  zipcode: locationModel.zipcode as ValidateJSModelAttribute<
    LocationUSCityStateZipInternationalCityModel,
    'zipcode'
  >,
  country: locationModel.country as ValidateJSModelAttribute<
    LocationUSCityStateZipInternationalCityModel,
    'country'
  >,
};

export default locationUSCityStateZipInternationalCityModelValidator;
